import { LocationsCounters } from '@recruitee/http/types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<LocationsCounters>()('LocationsCounters');

export {
  selectors as LocationCountersSelectors,
  actions as LocationCountersActions,
  reducer as LocationCountersReducer,
  namespace as LocationCountersNamespace,
};
